import React from 'react';
import { connectModal, hide } from 'redux-modal';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import catchError from '../../utils/catchError';
import ParkingSpotForm from './ParkingSpotForm';
import { addSpot } from '../../actions/parkingSpotActions';

function NewParkingSpotModal({ handleHide, lotId }) {
  const dispatch = useDispatch();

  async function handleSubmit(values, { resetForm }) {
    try {
      await dispatch(addSpot(values));
      toast.success(`Přidali jste nové parkovací místo`);
      handleHide();
      resetForm();
    } catch (err) {
      catchError(err);
    }
  }

  function handleCancel() {
    dispatch(hide('newParkingSpotModal'));
  }

  return (
    <div className="modal">
      <div className="modal__container">
        <div className="modal__body">
          <h2>Přidat parkovací místo</h2>
          <ParkingSpotForm
            initialValues={{ lot: lotId, place: '', owner: '', floor: '' }}
            handleSubmit={handleSubmit}
            handleCancel={handleCancel}
          />
        </div>
      </div>
    </div>
  );
}

export default connectModal({ name: 'newParkingSpotModal' })(
  NewParkingSpotModal
);
